import {
  SWITCH_ACCOUNT_URL
} from 'app/utils/Constants';

import {
  put
} from 'app/services/ApiService';

export const switchAccount = async params => {
  return await put(SWITCH_ACCOUNT_URL(), params);
}
